import React from "react";
import useClx from "../../../hooks/use-clx";
import clxs from "./property-item-skeleton.module.css";
import Skeleton from "../../Skeleton";
import useIsMobile from "../../../hooks/use-is-mobile";

interface PropertyItemSkeletonProps {
  className?: string;
}

function PropertyItemSkeleton(props: PropertyItemSkeletonProps) {
  const { className } = props;
  const ccx = useClx(clxs.container, className),
    { isMobile } = useIsMobile();
  return (
    <div className={ccx}>
      <div className={clxs.thumbnailContainer}>
        <Skeleton borderRadius={isMobile ? "4px 4px 0 0" : "4px 0 0 4px"} />
      </div>
      <div className={clxs.title}>
        <Skeleton />
      </div>
      <div className={clxs.subtitle}>
        <Skeleton />
      </div>
      <div className={clxs.specContainer}>
        <Skeleton />
      </div>
      <div className={clxs.collectionContainer}>
        <div className={clxs.collectionContent}>
          <div className={clxs.imageCollection}>
            <Skeleton borderRadius={"50%"} />
          </div>
          <div className={clxs.collection}>
            <Skeleton />
          </div>
        </div>
        <div className={clxs.collectionContent}>
          <div className={clxs.imageCollection}>
            <Skeleton borderRadius={"50%"} />
          </div>
          <div className={clxs.collection}>
            <Skeleton />
          </div>
        </div>
      </div>
      <div className={clxs.horizontalDivider}></div>
      <div className={clxs.pricingContainer}>
        <div className={clxs.priceContainer}>
          <div className={clxs.startFrom}>
            <div className={clxs.llpTicker}>
              <Skeleton />
            </div>
            <div className={clxs.strike}>
              <Skeleton />
            </div>
          </div>
          <div className={clxs.price}>
            <div className={clxs.amount}>
              <Skeleton />
            </div>
            <div className={clxs.excTax}>
              <Skeleton />
            </div>
          </div>
          <div className={clxs.totalAmount}>
            <Skeleton />
          </div>
        </div>
        <div className={clxs.view}>
          <Skeleton borderRadius={isMobile ? "50%" : ""} />
        </div>
      </div>
    </div>
  );
}

export default PropertyItemSkeleton;
